import { FC } from 'react';

type LoaderProps = {
    showLogo?: boolean;
}
const LoadingScreen: FC<LoaderProps> = ({showLogo}) => (
    <div className='loading-container' data-testid='0c878e34-c83e-4f5a-b31c-9f032f24431f'>
        <div className='loading-text' data-title='dot-spin-loader' data-testid="2032d402-f598-4655-9a40-2f07a4d39f8c">
            <div className='dot-spin-loader' data-testid="f0320968-5779-443d-89c1-96ef1e2bb984"></div>
        </div>
    </div>
)
LoadingScreen.displayName = 'LoadingView';
export default LoadingScreen;
